module.exports = __webpack_public_path__ + "img/india.fd9f0a79.png";